import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { ExcluirProdutosRequest } from '@shared/services/requests/orquestrador-suprimentos/excluir-produtos.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

/**
 * Exclusão de produto do cadastro (ProdutoOrquestradorController, bug 151221).
 * O orquestrador recusa o produto usado em ordem de produção, documento de venda, compra ou NF-e e só então
 * delega a exclusão à API Produto.
 */
@Injectable({ providedIn: 'root' })
export class ProdutoOrquestradorService extends CommonService {
  private readonly apiUrl = `${environment.urlApiOrquestradorSuprimentos}ProdutoOrquestrador`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public excluir(request: ExcluirProdutosRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/excluir`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
